import QA from './qa'

export default {
  data() {
    return {
      data:[]
    }
  },

  created() {
    this.$watch('id' , function(nv){
      if(nv){
        this.query()
      }else{
        this.data = []
      }
    },{immediate:true})
  },

  props: ['id'],

  methods: {
    query(){
      this.$request.courierExamRecord(this.id).then(resp => {
        resp.data = this.$utils.conv(resp.data || [], {'type':'$questionType'})
        resp.data.forEach((i , index) => {
          i.title = `${index+1}、${i.title}`
        })
        this.data = resp.data
      })
    }
  },

  render(){
    return <div style="margin:16px 8px;">
      {
        this.data.map(i => (
          <div style="display:flex;margin-bottom:20px;padding:0 5px;pointer-events:none;">
            <div>【{i.typeText}】</div>
            <QA data={i} />
          </div>
        ))
      }
    </div>
  }
}